const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the workflow list
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('workflowList', ['Application', 'Workflows', 'WorkflowResults', 'AccessHelper', '$translate', function (Application, Workflows, WorkflowResults, AccessHelper, $translate) {
  return {
    restrict: 'E',
    scope: {
    },
    template: require('../../templates/directives/workflow-list.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.order = 'name';
      self.translations = {};

      self.allowance = {
        workflows: AccessHelper.isAllowed(['admin', 'workflows'], null, ['admin', 'creator']),
      };

      if (!self.allowance.workflows) {
        Application.navigation.goTo('/explore');
        return;
      }

      self.update = function(body, id) {
        var fields = Object.keys(body).join(',');

        return Workflows.update({
          subresource: id,
          fields: fields
        }, body).$promise
      };

      self.editing = {
        current: null,
        toDelete: null,
        isCurrent: function(id) {
          return id === this.current;
        },
        edit: function(item) {
          if (this.current === item._id) {
            this.current = null;
            return;
          }
          this.current = item._id;
        },
        duplicateLoading: false,
        displayClone: false,
        flowToClone: null,
        cloneToggle: function(item) {
          this.flowToClone = item;
          this.displayClone = true;
          self.editing.clear();
        },
        clone: function() {
          if (self.editing.duplicateLoading) {
            return;
          }
          self.editing.duplicateLoading = true;
          Workflows.duplicate({subresource: self.editing.flowToClone._id}, {}).$promise
          .then(function(item) {
            self.initialize();
            self.editing.duplicateLoading = false;
            self.editing.displayClone = false;
          }).catch(function(error) {
            // handle error
            console.log('error in workshop duplication', error);
          });
        },
        clear: function() {
          this.current = null;
        },
        activate: function(item, action) {
          self.update({enabled: action}, item._id)
          .then(function(returned) {
            item.enabled = returned.enabled
            self.editing.clear();
            if (item.enabled) {
              $translate('workflowList.item_activated',{ name: item.name}).then(function (translation) {
                Application.messaging.addMessage({type: 'success', text: translation, duration: 7});
              });
              return;
            }
            $translate('workflowList.item_deactivated',{ name: item.name}).then(function (translation) {
              Application.messaging.addMessage({text: translation, duration: 7});
            });
          });
        },
        delete: function() {
          Workflows.remove({subresource: this.toDelete._id}).$promise
          .then(function(success) {
            for (var i = 0; i < self.workflows.length; i++) {
              if (self.workflows[i]._id === self.editing.toDelete._id) {
                self.workflows.splice(i, 1);
                break;
              }
            }
            self.editing.toDelete = null;
            Application.messaging.addMessage({type: 'success', text: self.translations['workflowList.workflow_deleted'], duration: 7});
          });
        },
        cancelDelete: function() {
          this.toDelete = null;
        }
      };

      self.rename = {
        renaming: null,
        isRenaming: function(id) {
          return id === this.renaming;
        },
        originalName: null,
        start: function(item) {
          if (self.renaming) {
            Application.messaging.addMessage({type: 'error', text: self.translations['workflowList.save_or_cancel_warning'], duration: 7});
            return;
          }
          this.renaming = item._id;
          this.originalName = item.name.slice(0);
          self.editing.clear();
        },
        save: function(item) {
          if (!item.name) {
            Application.messaging.addMessage({type: 'error', text: self.translations['workflowList.provide_name_warning'], duration: 7});
            return;
          }
          self.update({name: item.name}, item._id)
          .then(function(returned) {
            item.name = returned.name;
            self.rename.renaming = null;
            self.rename.originalName = null;
          });
        },
        cancel: function(item) {
          if (this.originalName) {
            item.name = this.originalName
          }
          this.renaming = null;
        }
      };
      self.statistics = {
        counts: {},
        userLists: {},
        showSearch: false,
        activeList: null,
        initialize: async function (workflowId) {
          const data = await WorkflowResults.get({workflowid: workflowId}).$promise;
          self.statistics.userLists[workflowId] = [];
          for (var i = 0; i < data.length; i++) {
            if (data[i].user) {
              self.statistics.userLists[workflowId].push(data[i].user._id);
            }
          }
          self.statistics.count(workflowId);

        },
        count: function(workflowId) {
          self.statistics.counts[workflowId] = self.statistics.userLists[workflowId].length
        },
        findUsers: async function(workflowId) {
          // set component user list
          self.statistics.activeList = self.statistics.userLists[workflowId];
          // show component
          if (self.statistics.activeList && self.statistics.activeList.length) {
            self.statistics.showSearch = true;
          }
        }
      };
      var sentto = false;
      self.changeOrder = function (field) {
        if (field === 'sentto') {
          if (sentto) {
            self.order = function(flow) {
              return self.statistics.counts[flow._id];
            };
            sentto = false;
            self.senttodirection = 'down';
            return;
          }
          self.order = function(flow) {
            return self.statistics.counts[flow._id] * -1;
          };
          sentto = true;
          self.senttodirection = 'up';
          return;
        }
        sentto = false;
        if (self.order === field) {
          self.order = '-' + field;
          return;
        }
        self.order = field;
        self.senttodirection = '';
      };
      self.initialize = function() {
        Workflows.find({
          fields: 'user,name,type,enabled,createdAt',
          'user-populate': 'first_name,last_name,full_name,image,email'
        }).$promise.then(function(items) {
          self.workflows = items;
          // get data from analyze
          for (var i = 0; i < items.length; i++) {
            if (items[i]._id && self.statistics.counts[items[i]._id]) {
              continue;
            }
            self.statistics.initialize(items[i]._id);
          }
        });
      };
      self.initialize();

      $translate([
        'workflowList.workflow_deleted',
        'workflowList.save_or_cancel_warning',
        'workflowList.provide_name_warning'
      ]).then(function (translations) {
        self.translations = translations;
      });

    }],
    controllerAs: 'list'
  }
}]);